import { createContext, useContext } from 'react';

/**
 * True for anything rendered inside `WorkQueueDetailDialog`. The dialog hosts whole detail
 * pages, so anything that would navigate reads this and opens a new tab instead —
 * otherwise the router moves the page behind the dialog, or stacks a second one over it.
 *
 * Its own module because `WorkQueueDetailDialog` pulls in all three detail pages.
 */
export const HostedInWorkQueueDialogContext = createContext(false);

export const useHostedInWorkQueueDialog = (): boolean => useContext(HostedInWorkQueueDialogContext);
